// extracted by mini-css-extract-plugin
module.exports = {"container":"VideoLesson_container__1FRAf","video":"VideoLesson_video__Z-Cp2","description":"VideoLesson_description__2BMO3","cf-videoLesson":"VideoLesson_cf-videoLesson__3ob4I"};